// @generated drizzle-zero signature:sha256:38652613d5b1ec012e48cac252a9b7bfcf322200c423b44abdb064cc6106352b
// This file was automatically generated by drizzle-zero.
// You should NOT make any changes in this file as it will be overwritten.

import type { Row } from "@rocicorp/zero";
import { createBuilder } from "@rocicorp/zero";
import type { ZeroCustomType } from "drizzle-zero";
import type { schema as zeroSchema } from "./drizzle-zero.config";

const amsClassicWorkoutTable = {
    "name": "AmsClassicWorkout",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "amsClassicEventId": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "ams_classic_event_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "workoutId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workout_id"
        },
        "version": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "ams_classic_workout",
    "uniqueKeys": [["orgId", "amsClassicEventId"], ["orgId", "profileId", "workoutId"]]
} as const;
const athleteActualWorkoutLayerTable = {
    "name": "AthleteActualWorkoutLayer",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        },
        "workoutId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workout_id"
        },
        "athleteVersion": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "athlete_version"
        },
        "blockVersion": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "block_version"
        },
        "layer": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "AthleteActualWorkoutLayer", "layer">
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "athlete_actual_workout_layer",
    "uniqueKeys": [["orgId", "blockId", "workoutId", "profileId"]]
} as const;
const athleteDraftWorkoutLayerTable = {
    "name": "AthleteDraftWorkoutLayer",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        },
        "cycleSortOrder": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "cycle_sort_order"
        },
        "sessionSortOrder": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "session_sort_order"
        },
        "workoutId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workout_id"
        },
        "assignedDate": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "assigned_date"
        },
        "excludeAssignedDate": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "exclude_assigned_date"
        },
        "unpublishedChangeCount": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "unpublished_change_count"
        },
        "layer": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "AthleteDraftWorkoutLayer", "layer">
        },
        "deletedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "deleted_at"
        },
        "name": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "athlete_draft_workout_layer",
    "uniqueKeys": [["orgId", "blockId", "workoutId", "profileId"]]
} as const;
const athleteModifiedPublishedWorkoutLayerTable = {
    "name": "AthleteModifiedPublishedWorkoutLayer",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        },
        "workoutId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workout_id"
        },
        "athleteVersion": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "athlete_version"
        },
        "blockVersion": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "block_version"
        },
        "layer": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "AthleteModifiedPublishedWorkoutLayer", "layer">
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "athlete_modified_published_workout_layer",
    "uniqueKeys": [["orgId", "blockId", "workoutId", "profileId"]]
} as const;
const athletePublishedWorkoutLayerTable = {
    "name": "AthletePublishedWorkoutLayer",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        },
        "cycleSortOrder": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "cycle_sort_order"
        },
        "sessionSortOrder": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "session_sort_order"
        },
        "workoutId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workout_id"
        },
        "version": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number
        },
        "blockVersion": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "block_version"
        },
        "isCurrent": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "is_current"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "completed" | "canceled" | "planned" | "skipped"
        },
        "statusUpdatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "status_updated_at"
        },
        "assignedDate": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "assigned_date"
        },
        "layer": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "AthletePublishedWorkoutLayer", "layer">
        },
        "name": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "recordType": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "AthletePublishedWorkoutLayer", "recordType">,
            "serverName": "record_type"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "athlete_published_workout_layer",
    "uniqueKeys": [["orgId", "blockId", "workoutId", "profileId", "version"]]
} as const;
const athleteTransferredBlockTable = {
    "name": "AthleteTransferredBlock",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "oldTeamId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "old_team_id"
        },
        "newTeamId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "new_team_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "athlete_transferred_block"
} as const;
const athleteTransferredTrackTable = {
    "name": "AthleteTransferredTrack",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "oldTeamId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "old_team_id"
        },
        "newTeamId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "new_team_id"
        },
        "trackId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "track_id"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "athlete_transferred_track"
} as const;
const blockTable = {
    "name": "Block",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "blockType": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "strength_training" | "bowling",
            "serverName": "block_type"
        },
        "cycleLabel": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "cycle_label"
        },
        "sessionLabel": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "session_label"
        },
        "startDate": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "start_date"
        },
        "endDate": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "end_date"
        },
        "trainingMaxRatio": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "training_max_ratio"
        },
        "trackId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "track_id"
        },
        "deletedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "deleted_at"
        },
        "layout": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "Block", "layout">
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "canceled" | "planned"
        },
        "autoSchedule": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "auto_schedule"
        },
        "allowFlexWorkouts": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "allow_flex_workouts"
        },
        "hasPublishedWorkouts": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "has_published_workouts"
        },
        "hasWorkoutsInProgress": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "has_workouts_in_progress"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "block"
} as const;
const blockDraftWorkoutLayerTable = {
    "name": "BlockDraftWorkoutLayer",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        },
        "cycleSortOrder": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "cycle_sort_order"
        },
        "sessionSortOrder": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "session_sort_order"
        },
        "workoutId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workout_id"
        },
        "assignedDate": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "assigned_date"
        },
        "unpublishedChangeCount": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "unpublished_change_count"
        },
        "layer": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "BlockDraftWorkoutLayer", "layer">
        },
        "deletedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "deleted_at"
        },
        "name": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "block_draft_workout_layer"
} as const;
const blockFocusTable = {
    "name": "BlockFocus",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "sortOrder": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "sort_order"
        },
        "focusId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "focus_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "block_focus",
    "uniqueKeys": [["orgId", "blockId", "focusId"], ["orgId", "blockId", "sortOrder"]]
} as const;
const blockPrintTaskTable = {
    "name": "BlockPrintTask",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        },
        "status": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "completed" | "canceled" | "pending" | "in_progress" | "failed" | "send_failed"
        },
        "workoutIds": {
            "type": "json",
            "optional": false,
            "customType": null as unknown as string[],
            "serverName": "workout_ids"
        },
        "profileIds": {
            "type": "json",
            "optional": false,
            "customType": null as unknown as string[],
            "serverName": "profile_ids"
        },
        "pdfUrl": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "pdf_url"
        },
        "printOptions": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "BlockPrintTask", "printOptions">,
            "serverName": "print_options"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "block_print_task"
} as const;
const blockPublishTaskTable = {
    "name": "BlockPublishTask",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        },
        "status": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "completed" | "canceled" | "pending" | "in_progress" | "failed" | "send_failed"
        },
        "totalWorkouts": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "total_workouts"
        },
        "completedWorkoutIds": {
            "type": "json",
            "optional": false,
            "customType": null as unknown as string[],
            "serverName": "completed_workout_ids"
        },
        "failedWorkouts": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "BlockPublishTask", "failedWorkouts">,
            "serverName": "failed_workouts"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "block_publish_task"
} as const;
const blockPublishedWorkoutLayerTable = {
    "name": "BlockPublishedWorkoutLayer",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "blockId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "block_id"
        },
        "cycleSortOrder": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "cycle_sort_order"
        },
        "sessionSortOrder": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "session_sort_order"
        },
        "workoutId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workout_id"
        },
        "version": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number
        },
        "isCurrent": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "is_current"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "completed" | "canceled" | "planned" | "skipped"
        },
        "assignedDate": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "assigned_date"
        },
        "layer": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "BlockPublishedWorkoutLayer", "layer">
        },
        "name": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "block_published_workout_layer",
    "uniqueKeys": [["orgId", "blockId", "workoutId", "version"]]
} as const;
const coachTeamMembershipTable = {
    "name": "CoachTeamMembership",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "teamId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "team_id"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "coach_team_membership",
    "uniqueKeys": [["orgId", "profileId", "teamId"]]
} as const;
const orgSettingsTable = {
    "name": "OrgSettings",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "oneRepMaxFormula": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "epley" | "brzycki" | "lander" | "lombardi" | "mayhew" | "oconner" | "wathan",
            "serverName": "one_rep_max_formula"
        },
        "defaultCycleLabel": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "default_cycle_label"
        },
        "defaultSessionLabel": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "default_session_label"
        },
        "defaultWeightUnit": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "kg" | "lbs",
            "serverName": "default_weight_unit"
        },
        "enableTeamLibrary": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "enable_team_library"
        },
        "requireExerciseMetadataFields": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "require_exercise_metadata_fields"
        },
        "showBaseLibrary": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "show_base_library"
        },
        "defaultCoachRole": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "OrgSettings", "defaultCoachRole">,
            "serverName": "default_coach_role"
        },
        "athleteUserTypeTakesPrecedence": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "athlete_user_type_takes_precedence"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "org_settings",
    "uniqueKeys": [["orgId"]]
} as const;
const phaseTable = {
    "name": "Phase",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "type": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "Phase", "type">
        },
        "color": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "startDate": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "start_date"
        },
        "endDate": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "end_date"
        },
        "teamId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "team_id"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "phase"
} as const;
const profileTable = {
    "name": "Profile",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "userId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "isActive": {
            "type": "boolean",
            "optional": false,
            "customType": null as unknown as boolean,
            "serverName": "is_active"
        },
        "hasLoginAccess": {
            "type": "boolean",
            "optional": false,
            "customType": null as unknown as boolean,
            "serverName": "has_login_access"
        },
        "axleProfileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "axle_profile_id"
        },
        "givenName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "given_name"
        },
        "preferredName": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "preferred_name"
        },
        "familyName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "family_name"
        },
        "email": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "primaryPhone": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "primary_phone"
        },
        "imageUrl": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "image_url"
        },
        "gender": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "birthdate": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        },
        "isCoach": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "is_coach"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "profile",
    "uniqueKeys": [["axleProfileId"]]
} as const;
const profilePermissionTable = {
    "name": "ProfilePermission",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "scope": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "org" | "team"
        },
        "permissions": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "ProfilePermission", "permissions">
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "profile_permission",
    "uniqueKeys": [["orgId", "profileId"]]
} as const;
const profileRoleTable = {
    "name": "ProfileRole",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "role": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as ZeroCustomType<typeof zeroSchema, "ProfileRole", "role">
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "profile_role",
    "uniqueKeys": [["orgId", "profileId"]]
} as const;
const profileTeamMembershipTable = {
    "name": "ProfileTeamMembership",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "teamId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "team_id"
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "coach" | "athlete"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "profile_team_membership",
    "uniqueKeys": [["orgId", "profileId", "teamId", "type"]]
} as const;
const athleteTeamAttributesTable = {
    "name": "AthleteTeamAttributes",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "teamId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "team_id"
        },
        "positions": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as string[]
        },
        "sportName": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "sport_name"
        },
        "athleteYear": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "athlete_year"
        },
        "jerseyNumber": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "jersey_number"
        },
        "athleteStatus": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "athlete_status"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "athlete_team_attributes",
    "uniqueKeys": [["orgId", "profileId", "teamId"]]
} as const;
const trackTable = {
    "name": "Track",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "teamId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "team_id"
        },
        "deletedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "deleted_at"
        },
        "archivedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "archived_at"
        },
        "sortOrder": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "sort_order"
        },
        "parentTrackId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "parent_track_id"
        },
        "color": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "track"
} as const;
const trackAthleteTable = {
    "name": "TrackAthlete",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "profileId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "profile_id"
        },
        "trackId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "track_id"
        },
        "deletedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "deleted_at"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "track_athlete",
    "uniqueKeys": [["orgId", "profileId", "trackId"]]
} as const;
const trainingFocusTable = {
    "name": "TrainingFocus",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "trainingTypeId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "training_type_id"
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "training_focus"
} as const;
const trainingTypeTable = {
    "name": "TrainingType",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_at"
        },
        "orgId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "org_id"
        },
        "createdById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by_id"
        },
        "updatedById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        }
    },
    "primaryKey": ["orgId", "id"],
    "serverName": "training_type",
    "uniqueKeys": [["orgId", "name"]]
} as const;
const athletePublishedWorkoutLayerRelationships = {
    "block": [{ "sourceField": ["orgId", "blockId"], "destField": ["orgId", "id"], "destSchema": "Block", "cardinality": "one" }],
    "blockPublishedWorkoutLayer": [{ "sourceField": ["orgId", "blockId", "workoutId", "blockVersion"], "destField": ["orgId", "blockId", "workoutId", "version"], "destSchema": "BlockPublishedWorkoutLayer", "cardinality": "one" }],
    "athleteActualWorkoutLayer": [{ "sourceField": ["orgId", "blockId", "workoutId", "profileId", "blockVersion", "version"], "destField": ["orgId", "blockId", "workoutId", "profileId", "blockVersion", "athleteVersion"], "destSchema": "AthleteActualWorkoutLayer", "cardinality": "one" }],
    "athleteModifiedPublishedWorkoutLayer": [{ "sourceField": ["orgId", "blockId", "workoutId", "profileId", "version"], "destField": ["orgId", "blockId", "workoutId", "profileId", "athleteVersion"], "destSchema": "AthleteModifiedPublishedWorkoutLayer", "cardinality": "one" }]
} as const;
const athleteTeamAttributesRelationships = {
    "profileTeamMemberships": [{ "sourceField": ["orgId", "profileId", "teamId"], "destField": ["orgId", "profileId", "teamId"], "destSchema": "ProfileTeamMembership", "cardinality": "many" }]
} as const;
const blockFocusRelationships = {
    "block": [{ "sourceField": ["orgId", "blockId"], "destField": ["orgId", "id"], "destSchema": "Block", "cardinality": "one" }],
    "focus": [{ "sourceField": ["orgId", "focusId"], "destField": ["orgId", "id"], "destSchema": "TrainingFocus", "cardinality": "one" }]
} as const;
const blockPublishTaskRelationships = {
    "block": [{ "sourceField": ["orgId", "blockId"], "destField": ["orgId", "id"], "destSchema": "Block", "cardinality": "one" }]
} as const;
const blockPrintTaskRelationships = {
    "block": [{ "sourceField": ["orgId", "blockId"], "destField": ["orgId", "id"], "destSchema": "Block", "cardinality": "one" }]
} as const;
const blockPublishedWorkoutLayerRelationships = {
    "block": [{ "sourceField": ["orgId", "blockId"], "destField": ["orgId", "id"], "destSchema": "Block", "cardinality": "one" }]
} as const;
const blockRelationships = {
    "focuses": [{ "sourceField": ["orgId", "id"], "destField": ["orgId", "blockId"], "destSchema": "BlockFocus", "cardinality": "many" }],
    "athletePublishedWorkoutLayers": [{ "sourceField": ["orgId", "id"], "destField": ["orgId", "blockId"], "destSchema": "AthletePublishedWorkoutLayer", "cardinality": "many" }],
    "track": [{ "sourceField": ["orgId", "trackId"], "destField": ["orgId", "id"], "destSchema": "Track", "cardinality": "one" }]
} as const;
const coachTeamMembershipRelationships = {
    "profile": [{ "sourceField": ["orgId", "profileId"], "destField": ["orgId", "id"], "destSchema": "Profile", "cardinality": "one" }]
} as const;
const profileTeamMembershipRelationships = {
    "profile": [{ "sourceField": ["orgId", "profileId"], "destField": ["orgId", "id"], "destSchema": "Profile", "cardinality": "one" }],
    "teamMembershipAttributes": [{ "sourceField": ["orgId", "profileId", "teamId"], "destField": ["orgId", "profileId", "teamId"], "destSchema": "AthleteTeamAttributes", "cardinality": "one" }]
} as const;
const profileRelationships = {
    "teamMemberships": [{ "sourceField": ["orgId", "id"], "destField": ["orgId", "profileId"], "destSchema": "ProfileTeamMembership", "cardinality": "many" }],
    "coachTeamMemberships": [{ "sourceField": ["orgId", "id"], "destField": ["orgId", "profileId"], "destSchema": "CoachTeamMembership", "cardinality": "many" }],
    "athleteMemberships": [{ "sourceField": ["orgId", "id"], "destField": ["orgId", "profileId"], "destSchema": "ProfileTeamMembership", "cardinality": "many" }],
    "trackAthletes": [{ "sourceField": ["orgId", "id"], "destField": ["orgId", "profileId"], "destSchema": "TrackAthlete", "cardinality": "many" }]
} as const;
const trackAthleteRelationships = {
    "track": [{ "sourceField": ["orgId", "trackId"], "destField": ["orgId", "id"], "destSchema": "Track", "cardinality": "one" }],
    "profile": [{ "sourceField": ["orgId", "profileId"], "destField": ["orgId", "id"], "destSchema": "Profile", "cardinality": "one" }]
} as const;
const trackRelationships = {
    "athletes": [{ "sourceField": ["orgId", "id"], "destField": ["orgId", "trackId"], "destSchema": "TrackAthlete", "cardinality": "many" }],
    "blocks": [{ "sourceField": ["orgId", "id"], "destField": ["orgId", "trackId"], "destSchema": "Block", "cardinality": "many" }]
} as const;
const trainingFocusRelationships = {
    "trainingType": [{ "sourceField": ["orgId", "trainingTypeId"], "destField": ["orgId", "id"], "destSchema": "TrainingType", "cardinality": "one" }]
} as const;
/**
 * The Zero schema object.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const schema = {
    "tables": {
        "AmsClassicWorkout": amsClassicWorkoutTable,
        "AthleteActualWorkoutLayer": athleteActualWorkoutLayerTable,
        "AthleteDraftWorkoutLayer": athleteDraftWorkoutLayerTable,
        "AthleteModifiedPublishedWorkoutLayer": athleteModifiedPublishedWorkoutLayerTable,
        "AthletePublishedWorkoutLayer": athletePublishedWorkoutLayerTable,
        "AthleteTransferredBlock": athleteTransferredBlockTable,
        "AthleteTransferredTrack": athleteTransferredTrackTable,
        "Block": blockTable,
        "BlockDraftWorkoutLayer": blockDraftWorkoutLayerTable,
        "BlockFocus": blockFocusTable,
        "BlockPrintTask": blockPrintTaskTable,
        "BlockPublishTask": blockPublishTaskTable,
        "BlockPublishedWorkoutLayer": blockPublishedWorkoutLayerTable,
        "CoachTeamMembership": coachTeamMembershipTable,
        "OrgSettings": orgSettingsTable,
        "Phase": phaseTable,
        "Profile": profileTable,
        "ProfilePermission": profilePermissionTable,
        "ProfileRole": profileRoleTable,
        "ProfileTeamMembership": profileTeamMembershipTable,
        "AthleteTeamAttributes": athleteTeamAttributesTable,
        "Track": trackTable,
        "TrackAthlete": trackAthleteTable,
        "TrainingFocus": trainingFocusTable,
        "TrainingType": trainingTypeTable
    },
    "relationships": {
        "AthletePublishedWorkoutLayer": athletePublishedWorkoutLayerRelationships,
        "AthleteTeamAttributes": athleteTeamAttributesRelationships,
        "BlockFocus": blockFocusRelationships,
        "BlockPublishTask": blockPublishTaskRelationships,
        "BlockPrintTask": blockPrintTaskRelationships,
        "BlockPublishedWorkoutLayer": blockPublishedWorkoutLayerRelationships,
        "Block": blockRelationships,
        "CoachTeamMembership": coachTeamMembershipRelationships,
        "ProfileTeamMembership": profileTeamMembershipRelationships,
        "Profile": profileRelationships,
        "TrackAthlete": trackAthleteRelationships,
        "Track": trackRelationships,
        "TrainingFocus": trainingFocusRelationships
    },
    "enableLegacyQueries": false,
    "enableLegacyMutators": false
} as const;

/**
 * Represents the Zero schema type.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Schema = typeof schema;
/**
 * Represents a row from the "AmsClassicWorkout" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AmsClassicWorkout = Row<(typeof schema)["tables"]["AmsClassicWorkout"]>;
/**
 * Represents a row from the "AthleteActualWorkoutLayer" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AthleteActualWorkoutLayer = Row<(typeof schema)["tables"]["AthleteActualWorkoutLayer"]>;
/**
 * Represents a row from the "AthleteDraftWorkoutLayer" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AthleteDraftWorkoutLayer = Row<(typeof schema)["tables"]["AthleteDraftWorkoutLayer"]>;
/**
 * Represents a row from the "AthleteModifiedPublishedWorkoutLayer" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AthleteModifiedPublishedWorkoutLayer = Row<(typeof schema)["tables"]["AthleteModifiedPublishedWorkoutLayer"]>;
/**
 * Represents a row from the "AthletePublishedWorkoutLayer" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AthletePublishedWorkoutLayer = Row<(typeof schema)["tables"]["AthletePublishedWorkoutLayer"]>;
/**
 * Represents a row from the "AthleteTransferredBlock" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AthleteTransferredBlock = Row<(typeof schema)["tables"]["AthleteTransferredBlock"]>;
/**
 * Represents a row from the "AthleteTransferredTrack" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AthleteTransferredTrack = Row<(typeof schema)["tables"]["AthleteTransferredTrack"]>;
/**
 * Represents a row from the "Block" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Block = Row<(typeof schema)["tables"]["Block"]>;
/**
 * Represents a row from the "BlockDraftWorkoutLayer" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BlockDraftWorkoutLayer = Row<(typeof schema)["tables"]["BlockDraftWorkoutLayer"]>;
/**
 * Represents a row from the "BlockFocus" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BlockFocus = Row<(typeof schema)["tables"]["BlockFocus"]>;
/**
 * Represents a row from the "BlockPrintTask" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BlockPrintTask = Row<(typeof schema)["tables"]["BlockPrintTask"]>;
/**
 * Represents a row from the "BlockPublishTask" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BlockPublishTask = Row<(typeof schema)["tables"]["BlockPublishTask"]>;
/**
 * Represents a row from the "BlockPublishedWorkoutLayer" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BlockPublishedWorkoutLayer = Row<(typeof schema)["tables"]["BlockPublishedWorkoutLayer"]>;
/**
 * Represents a row from the "CoachTeamMembership" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type CoachTeamMembership = Row<(typeof schema)["tables"]["CoachTeamMembership"]>;
/**
 * Represents a row from the "OrgSettings" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type OrgSetting = Row<(typeof schema)["tables"]["OrgSettings"]>;
/**
 * Represents a row from the "Phase" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Phase = Row<(typeof schema)["tables"]["Phase"]>;
/**
 * Represents a row from the "Profile" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Profile = Row<(typeof schema)["tables"]["Profile"]>;
/**
 * Represents a row from the "ProfilePermission" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ProfilePermission = Row<(typeof schema)["tables"]["ProfilePermission"]>;
/**
 * Represents a row from the "ProfileRole" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ProfileRole = Row<(typeof schema)["tables"]["ProfileRole"]>;
/**
 * Represents a row from the "ProfileTeamMembership" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ProfileTeamMembership = Row<(typeof schema)["tables"]["ProfileTeamMembership"]>;
/**
 * Represents a row from the "AthleteTeamAttributes" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AthleteTeamAttribute = Row<(typeof schema)["tables"]["AthleteTeamAttributes"]>;
/**
 * Represents a row from the "Track" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Track = Row<(typeof schema)["tables"]["Track"]>;
/**
 * Represents a row from the "TrackAthlete" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type TrackAthlete = Row<(typeof schema)["tables"]["TrackAthlete"]>;
/**
 * Represents a row from the "TrainingFocus" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type TrainingFocus = Row<(typeof schema)["tables"]["TrainingFocus"]>;
/**
 * Represents a row from the "TrainingType" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type TrainingType = Row<(typeof schema)["tables"]["TrainingType"]>;

/**
 * Represents the ZQL query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const zql = createBuilder(schema);
/**
 * Represents the Zero schema query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const builder = zql;

/** Defines the default types for Zero */
declare module '@rocicorp/zero' { interface DefaultTypes { schema: Schema; } }
